(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hok-floating-video"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  var DISMISS_KEY = 'hok_fv_dismissed';

  function initAll(scope) {
    var roots = (scope || document).querySelectorAll('[data-hok-fv]');
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  }

  function init(root) {
    if (root.__hokFvInit) return;
    root.__hokFvInit = true;

    var stage    = root.querySelector('[data-hok-fv-stage]');
    var video    = root.querySelector('[data-hok-fv-video]');
    var soundBtn = root.querySelector('[data-hok-fv-sound]');
    var closeBtn = root.querySelector('[data-hok-fv-close]');

    if (!video || !stage) return;

    // Respect session dismissal
    try {
      if (sessionStorage.getItem(DISMISS_KEY) === '1') {
        root.remove();
        return;
      }
    } catch (e) {}

    // Respect Data Saver / metered connections
    try {
      var conn = navigator.connection;
      if (conn && conn.saveData) {
        root.remove();
        return;
      }
    } catch (e) {}

    var delayMs = parseInt(root.getAttribute('data-delay'), 10);
    if (isNaN(delayMs) || delayMs < 0) delayMs = 0;

    var afterLoad = function () {
      // requestIdleCallback if available, else fallback to setTimeout
      var kick = function () { setTimeout(reveal, delayMs); };
      if ('requestIdleCallback' in window) {
        window.requestIdleCallback(kick, { timeout: 2000 });
      } else {
        setTimeout(kick, 0);
      }
    };

    if (document.readyState === 'complete') {
      afterLoad();
    } else {
      window.addEventListener('load', afterLoad, { once: true });
    }

    function reveal() {
      console.log('[hok-fv] reveal() firing', { id: root.id });
      loadSources();
      video.muted = true;               // Explicit — attribute alone isn't always enough
      video.setAttribute('muted', '');
      tryPlay();
      root.setAttribute('data-state', 'visible');
      root.setAttribute('aria-hidden', 'false');
    }

    function loadSources() {
      var sources = video.querySelectorAll('source[data-hok-fv-source]');
      if (!sources.length) {
        console.warn('[hok-fv] no <source> elements found in <video>');
        return;
      }

      console.log('[hok-fv] promoting', sources.length, 'source(s) to real src');

      Array.prototype.forEach.call(sources, function (s) {
        var url = s.getAttribute('data-src');
        var type = s.getAttribute('data-type');
        if (url && !s.getAttribute('src')) s.src = url;
        if (type && !s.getAttribute('type')) s.type = type;
      });

      video.load();

      video.addEventListener('error', function () {
        console.error('[hok-fv] <video> error', video.error);
      });
    }

    function tryPlay() {
      var attempt = function (tag) {
        var p = video.play();
        if (p && typeof p.catch === 'function') {
          p.then(function () {
            console.log('[hok-fv] play() OK (' + tag + ')');
          }).catch(function (err) {
            console.warn('[hok-fv] play() failed (' + tag + '):', err.name, err.message);
          });
        }
      };
      // First attempt right away
      attempt('immediate');
      // Second attempt once data is buffered — covers the case where the
      // first attempt fired before <source> resolved
      video.addEventListener('canplay', function once () {
        video.removeEventListener('canplay', once);
        if (video.paused) attempt('canplay');
      });
    }

    if (soundBtn) {
      soundBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        video.muted = !video.muted;
        root.setAttribute('data-muted', String(video.muted));
        soundBtn.setAttribute(
          'aria-label',
          video.muted ? 'Unmute video' : 'Mute video'
        );
      });
    }

    if (closeBtn) {
      closeBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        try { sessionStorage.setItem(DISMISS_KEY, '1'); } catch (err) {}
        video.pause();
        root.removeAttribute('data-state');
        root.setAttribute('aria-hidden', 'true');
        // Fully remove after transition ends
        setTimeout(function () { root.remove(); }, 500);
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  // Theme editor: reinitialise when a section is added or reloaded
  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
